import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 .5h48v48H0z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "32",
  height: "24",
  x: "8",
  y: "12.5",
  stroke: "#475467",
  "stroke-width": "2",
  rx: "1"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#475467",
  "stroke-width": "2",
  d: "M8 13.5a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1v3H8v-3ZM16 11.5v6M16 31.5v6M24 11.5v6M24 31.5v6M32 11.5v6M32 31.5v6M8 32.5h32v3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-3Z"
}, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#475467",
  d: "M21 20.784c0-.584 0-.876.121-1.04a.607.607 0 0 1 .444-.243c.202-.015.446.143.935.46l5.743 3.715c.424.274.636.411.709.586a.616.616 0 0 1 0 .476c-.073.175-.285.312-.709.586L22.5 29.04c-.489.316-.733.474-.935.46a.607.607 0 0 1-.444-.245C21 29.092 21 28.8 21 28.215v-7.43Z"
}, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }